/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Global_StatusInputs */

const en_global_status = /** @type {(inputs: Global_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Global Status`)
};

const es_global_status = /** @type {(inputs: Global_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estado global`)
};

const fr_global_status = /** @type {(inputs: Global_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut global`)
};

const de_global_status = /** @type {(inputs: Global_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Globaler Status`)
};

const ja_global_status = /** @type {(inputs: Global_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グローバルステータス`)
};

const zh_global_status = /** @type {(inputs: Global_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全球状态`)
};

const ar_global_status = /** @type {(inputs: Global_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحالة العالمية`)
};

const id_global_status = /** @type {(inputs: Global_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status Global`)
};

const it_global_status = /** @type {(inputs: Global_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status Globale`)
};

const ru_global_status = /** @type {(inputs: Global_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Глобальный статус`)
};

const pt_global_status = /** @type {(inputs: Global_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status Global`)
};

const ko_global_status = /** @type {(inputs: Global_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`글로벌 상태`)
};

/**
* | output |
* | --- |
* | "Global Status" |
*
* @param {Global_StatusInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const global_status = /** @type {((inputs?: Global_StatusInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Global_StatusInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_global_status(inputs)
	if (locale === "es") return es_global_status(inputs)
	if (locale === "fr") return fr_global_status(inputs)
	if (locale === "de") return de_global_status(inputs)
	if (locale === "ja") return ja_global_status(inputs)
	if (locale === "zh") return zh_global_status(inputs)
	if (locale === "ar") return ar_global_status(inputs)
	if (locale === "id") return id_global_status(inputs)
	if (locale === "it") return it_global_status(inputs)
	if (locale === "ru") return ru_global_status(inputs)
	if (locale === "pt") return pt_global_status(inputs)
	return ko_global_status(inputs)
});